import { useRef, useEffect } from "react";

/**
 * Uses a ref that persists any value between renders.
 */
export function useLatestRef(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}